window.initMcQuizFinder = function (sectionId) {
  const root = document.getElementById('pump-finder-' + sectionId);
  if (!root || root.dataset.mcQuizInit) return;
  root.dataset.mcQuizInit = 'true';

  const products = (window.MC_QUIZ_PRODUCTS && window.MC_QUIZ_PRODUCTS[sectionId]) || [];
  const state = { step: 1, answers: {}, recommended: null };

  const $ = (id) => document.getElementById(id + '-' + sectionId);
  const questions = root.querySelectorAll('.mc-question');
  const totalSteps = questions.length;

  function updateProgress() {
    const bar = $('quizProgress');
    if (bar) bar.style.width = Math.max(20, Math.round((state.step / totalSteps) * 100)) + '%';
    const back = $('quizBack');
    const next = $('quizNext');
    const currentQ = root.querySelector('.mc-question[data-step="' + state.step + '"]');
    const selected = currentQ ? currentQ.querySelector('.mc-option.is-selected') : null;
    if (back) back.disabled = state.step === 1;
    if (next) {
      next.textContent = state.step === totalSteps ? 'Show my match' : 'Next';
      next.disabled = !selected;
    }
  }

  function showStep(step) {
    state.step = Math.min(totalSteps, Math.max(1, step));
    questions.forEach((q) => q.classList.remove('is-active'));
    const active = root.querySelector('.mc-question[data-step="' + state.step + '"]');
    if (active) active.classList.add('is-active');
    updateProgress();
  }

  function scoreProduct(p) {
    if (!p.tags || !p.tags.length) return 0;
    let score = 0;
    Object.values(state.answers).forEach((val) => {
      if (p.tags.indexOf(val) !== -1) score++;
    });
    return score;
  }

  function stars(n) {
    const full = Math.round(Number(n) || 0);
    return '★★★★★☆☆☆☆☆'.slice(5 - full, 10 - full);
  }

  function recommend() {
    if (!products.length) return;
    let best = products[0];
    let bestScore = -1;
    products.forEach((p) => {
      const s = scoreProduct(p);
      if (s > bestScore) { bestScore = s; best = p; }
    });
    state.recommended = best;

    const media = $('quizResultMedia');
    if (media) {
      media.innerHTML = best.image
        ? '<img src="' + best.image + '" alt="' + best.model + '">'
        : '<div>' + best.model + '</div>';
    }
    const set = (id, val) => { const el = $(id); if (el) el.textContent = val; };
    set('quizResultTitle', best.model);
    set('quizResultReason', best.reason || '');
    const starsEl = $('quizResultStars'); if (starsEl) starsEl.textContent = stars(best.rating);
    set('quizResultPrice', best.price || '');
    const mrp = $('quizResultMrp'); if (mrp) mrp.textContent = best.compareAt || '';

    let saveText = '';
    if (best.compareAt) {
      const c = parseFloat(String(best.compareAt).replace(/[^\d.]/g, ''));
      const pr = parseFloat(String(best.price).replace(/[^\d.]/g, ''));
      if (c > pr) {
        const pct = Math.round(((c - pr) / c) * 100);
        saveText = 'Save ' + pct + '%';
      }
    }
    set('quizResultSave', saveText);

    const view = $('quizViewProduct');
    if (view) view.setAttribute('href', best.url || '#');

    const result = $('quizResult');
    if (result) {
      result.classList.add('is-visible');
      result.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  root.querySelectorAll('.mc-option').forEach((btn) => {
    btn.addEventListener('click', function () {
      const q = this.closest('.mc-question');
      if (q) q.querySelectorAll('.mc-option').forEach((b) => b.classList.remove('is-selected'));
      this.classList.add('is-selected');
      if (this.dataset.field) state.answers[this.dataset.field] = this.dataset.value;
      updateProgress();
    });
  });

  const nextBtn = $('quizNext');
  const backBtn = $('quizBack');
  if (nextBtn) nextBtn.addEventListener('click', () => {
    if (state.step < totalSteps) showStep(state.step + 1);
    else recommend();
  });
  if (backBtn) backBtn.addEventListener('click', () => showStep(state.step - 1));

 const addBtn = $('quizAddToCart');
if (addBtn) {
  addBtn.addEventListener('click', async function () {
    const p = state.recommended;
    if (!p || !p.variantId) { addBtn.textContent = 'Not available'; return; }
    const original = addBtn.textContent;
    addBtn.textContent = 'Adding...';
    try {
      // 1. Add to cart
      const addRes = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: Number(p.variantId), quantity: 1 })
      });
      if (!addRes.ok) throw new Error();
      await addRes.json();

      addBtn.textContent = 'Added ✓';

      // 2. Fetch fresh cart-drawer section HTML (same as native product-form does)
      const sectionRes = await fetch('/cart?sections=cart-drawer');
      const sectionData = await sectionRes.json();
      const html = sectionData['cart-drawer'];

      if (html) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newDrawer = doc.querySelector('cart-drawer');
        const oldDrawer = document.querySelector('cart-drawer');
        if (newDrawer && oldDrawer) {
          oldDrawer.replaceWith(newDrawer);
        }
      }

      // 3. Open the (now-refreshed) native drawer
      const drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') {
        drawer.open();
      }

      setTimeout(() => { addBtn.textContent = original; }, 2000);
    } catch (e) {
      addBtn.textContent = 'Try again';
      setTimeout(() => { addBtn.textContent = original; }, 2000);
    }
  });
}

  showStep(1);
};